import { logService } from '../services'
import Vue from 'vue'

const state = {
  all: {
    filterInitialized: false,
    items: {},
    saving: false
  }
}

const actions = {

  getById ({ commit }, id) {
    return logService.getById(id)
  },

  getByProjectId ({ commit }, id) {
    logService.getByProjectId(id)
      .then(
        data => {
          commit('getByProjectIdSuccess', data.result)
        }
      )
  },

  create ({ commit, dispatch }, log) {
    commit('startSave')
    return logService.create(log)
      .then(log => {
        commit('endSave')
        commit('createSuccess', log.result)
        // dispatch('getListData')
        return log.result
      }).catch(error => {
        commit('endSave')
        commit('createFailure')
        return Promise.reject(error)
      })
  },

  update ({ commit }, log) {
    commit('startSave')
    return logService.update(log)
      .then(log => {
        commit('endSave')
        commit('updateSuccess', log.result)
        return log.result
      }).catch(error => {
        commit('endSave')
        commit('updateFailure')
        return Promise.reject(error)
      })
  },

  delete ({ commit }, id) {
    commit('startSave')
    commit('deleteRequest', id)

    logService.delete(id)
      .then(log => {
        commit('endSave')
        commit('deleteSuccess', id)
      })
  }
}

const mutations = {
  startSave (state) {
    state.all.saving = true
  },
  endSave (state) {
    setTimeout(() => {
      state.all.saving = false
    }, 200)
  },

  getByProjectIdRequest (state) {
    state.all.loading = true
  },
  getByProjectIdSuccess (state, data) {
    state.all.items = data
  },
  getByProjectIdFailure (state, error) {
    state.all.error = error
  },

  // Create
  createSuccess (state, updatedLog) {
    Vue.prototype.$toast('Loggmeddelande skapat', 'success')
  },
  createFailure (state, error) {
    Vue.prototype.$toast('Kunde inte skapa Loggmeddelande', 'error')
  },

  // Update
  updateSuccess (state, updatedLog) {
    state.all.items = state.all.items.map(log =>
      log.projectLogId === updatedLog.projectLogId ? updatedLog : log
    )

    Vue.prototype.$toast('Loggmeddelande uppdaterat', 'success')
  },
  updateFailure (state) {
    Vue.prototype.$toast('Kunde inte uppdatera loggmeddelandet', 'error')
  },

  // Delete
  deleteRequest (state, id) {
    state.all.items = state.all.items.map(log =>
      log.projectLogId === id
        ? { ...log, deleting: true }
        : log
    )
  },
  deleteSuccess (state, id) {
    state.all.items = state.all.items.filter(log => log.projectLogId !== id)
  }
}
const getters = {
  getAllLogs: state => {
    return state.all.items
  }
}

export const logs = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/logs.module.js